import { Injectable } from "@angular/core";
import { Agente } from "@tivic-team/manager-ts/dist/mob/entities/agente.entity";
import { ApiController } from 'app/controllers/api-controller.interface';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environmentv3 } from "src/environments/environmentv3";


@Injectable()
export class AgenteController implements ApiController<Agente> {
    
    constructor() { }

    async findAgente(filtros?: IFilter): Promise<Array<Agente>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/agentes',
                    environment: environmentv3,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<Agente>()
            )
        );
        return await quark.call();
    }

    async find(filtros?: IFilter): Promise<Array<Agente>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/agentes/agente',
                    environment: environmentv3,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<Agente>()
            )
        );
        return await quark.call();
    }

    async get(cdAgente: number): Promise<Agente>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/agentes/:cdAgente',
                    environment: environmentv3,
                    pathParams: new JSONData({ cdAgente: cdAgente})
                }),
            }),
            new HttpResponse(
                new Agente()
            )
        );

        return await quark.call();
    }

    create(entity: Agente): Promise <Agente> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/agentes',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Agente()
            )
        );
    
        return request.call();
    }

    update(entity: Agente): Promise <Agente> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/agentes/:cdAgente',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdAgente: entity.cdAgente
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Agente()
            )
        );
        return request.call();
    }
}